import { Section } from "./section";
import "./contact.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faLinkedinIn, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

export class Contact extends Section {
    constructor() {
        super();
    }

    id = "contact";
    name = "Contato";
    isVisible = true;
    element = () => {
        return <div className="container">
            <div className="logo">
                <img src="/images/passify-dark.svg" />    
            </div>
            <div className="header">
                <h2>Contato</h2>
                <h3>Bora trabalhar juntos!</h3>
                <p>Tudo o que você precisar para dominar a gestão dos seus eventos de forma leve, simples e fácil!</p>
                <p><b>contato@passify.co<br/>+55 (11) 95662-1753<br />São Paulo - Brasil</b></p>
                <div className="social-buttons">
                    <a href="https://wa.me/+5511956621753" target="_blank"><FontAwesomeIcon icon={faWhatsapp} /></a>
                    <a href="mailto:contato@passify.co"><FontAwesomeIcon icon={faEnvelope} /></a>
                    <a href="https://www.linkedin.com/company/passify-co"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                    <a href="https://instagram.com/passify.co"><FontAwesomeIcon icon={faInstagram} /></a>
                </div>
            </div>
        </div>;
    }
}